import { TabContent, TabPane } from "reactstrap";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import Contact from "./MainSidebarTab/Contact";
import Status from "./MainSidebarTab/Status/Status";
import Notification from "./MainSidebarTab/Notification";
import Document from "./MainSidebarTab/Document";
import Favorite from "./MainSidebarTab/Favorite";
import Settings from "./MainSidebarTab/Settings";
import RecentSection from "./RecentSection";
import ChatSection from "./ChatSection";

const LeftSidebarChat = () => {
  const { mainSidebarActiveTab } = useAppSelector((state) => state.mainSidebar);
  return (
    <aside className="chatzy-left-sidebar left-disp">
      <div className="recent-default dynemic-sidebar active">
        <RecentSection />
        <ChatSection />
      </div>
      <TabContent activeTab={mainSidebarActiveTab}>
        <TabPane tabId="status" className="status-tab custom-scroll dynemic-sidebar">
          <Status />
        </TabPane>
        <TabPane tabId="contact-list" className="contact-list-tab dynemic-sidebar custom-scroll">
          <Contact />
        </TabPane>
        <TabPane tabId="notification" className="notification-tab dynemic-sidebar custom-scroll">
          <Notification />
        </TabPane>
        <TabPane tabId="document" className="document-tab custom-scroll dynemic-sidebar">
          <Document />
        </TabPane>
        <TabPane tabId="favorite" className="fevorite-tab custom-scroll dynemic-sidebar">
          <Favorite />
        </TabPane>
        <TabPane tabId="settings" className="settings-tab dynemic-sidebar custom-scroll">
          <Settings />
        </TabPane>
      </TabContent>
    </aside>
  );
};

export default LeftSidebarChat;
